<template>
	<button
		v-if="player.is_queued"
		class="base-btn remove_btn"
		@click="remove_from_queue(player.player_id)"
	>
		Remove from Queue
	</button>
	<button
		v-else
		class="base-btn add_btn"
		@click="add_to_queue(player.player_id)"
	>
		Add to Queue
	</button>
</template>

<style lang="scss" scoped>
.remove_btn {
	@apply bg-red-600 hover:bg-red-900;
}

.add_btn {
	@apply bg-green-600 hover:bg-green-900;
}
</style>

<script>
import { mapState } from 'vuex';
import { QUEUE_PLAYER_ADD, QUEUE_PLAYER_REMOVE } from '@/store/actions/queue';

export default {
	computed: {
		...mapState({
			room_id: state => state.room.id,
		}),
	},
	props: {
		player: Object,
	},
	methods: {
		remove_from_queue(player_id) {
			this.$store.commit(QUEUE_PLAYER_REMOVE, this.payload(player_id));
			this.player.is_queued = false;
		},
		add_to_queue(player_id) {
			this.$store.commit(QUEUE_PLAYER_ADD, this.payload(player_id));
			//TODO: have store module store an error, use that to determine if it continue
			this.player.is_queued = true;
		},
		payload(player_id) {
			return {
				player_id,
				room_id: this.room_id,
			};
		},
	},
};
</script>
